import React, { useEffect, useState } from "react";
import { Typography, CircularProgress, Button, Box } from "@material-ui/core";
import { Field, Form } from "react-final-form";
import RFTextField from "../modules/RFTextField";
import { useHistory } from "react-router-dom";
import { authenticationService } from "../services";
import fondoImage from "../assets/images/fondo.jpg";
import "./Login.css";

const Login = ({ onAuthChange }) => {
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    authenticationService.logout();
  }, []);

  const onSubmit = async (values) => {
    setSubmitting(true);
    setErrorMessage("");
    try {
      const response = await authenticationService.login(
        values.username,
        values.password
      );
      if (response && response.token) {
        if (onAuthChange) {
          onAuthChange();
        }
        history.push("/solicitudes");
      } else {
        setErrorMessage("Usuario o contraseña inválidos.");
      }
    } catch (error) {
      setErrorMessage("Ocurrió un error al iniciar sesión. Intente nuevamente.");
    } finally {
      setSubmitting(false);
            }
  };

  return (
    <section className="login-page">
      <div className="login-card">
        <div className="login-form">
          <Box className="login-form-content">
            <Typography variant="h5" component="h3" gutterBottom className="login-title">
              Iniciar sesión
            </Typography>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Field
                    autoComplete="username"
                    component={RFTextField}
                    fullWidth
                    placeholder="Usuario"
                    variant="outlined"
                    margin="normal"
                    name="username"
                    type="text"
                    required
                  />
                  <Field
                    fullWidth
                    component={RFTextField}
                    required
                    name="password"
                    variant="outlined"
                    placeholder="Contraseña"
                    type="password"
                    margin="normal"
                  />
                  <div className="login-actions">
                    <Button
                      className="btn-login"
                      type="submit"
                      variant="contained"
                      disabled={submitting}
                      fullWidth
                    >
                      {submitting ? (
                        <CircularProgress size={22} color="inherit" />
                      ) : (
                        "Iniciar sesión"
                      )}
                    </Button>
                  </div>
                  {errorMessage && (
                    <Typography variant="body2" className="login-error">
                      {errorMessage}
                    </Typography>
                  )}
                </form>
              )}
            />
          </Box>
        </div>
        <div className="login-hero" style={{ backgroundImage: `url(${fondoImage})` }}>
          <div className="login-hero-content">
            <div className="login-hero-badge">
              <Typography variant="body2" className="login-hero-badge-text">
                Vas a ingresar a:
              </Typography>
            </div>
            <Typography variant="h3" component="h2" className="login-hero-title">
              Portal de gestión de clientes
            </Typography>
            <Typography variant="h4" component="h1" className="login-hero-brand">
              ST SECURITIES
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
